import { readable } from 'svelte/store'   // readable, writable, derived
import { urlServeur } from '../components/conf.js'

export const effectif = readable([], async (set) => {
    const response = await fetch(urlServeur +  "/api_employe/employes")
    const res = await response.json()
    const data = await res.payload
    console.dir(data)
    set(data)
    return () => { };
});

